import { useQuery } from '@tanstack/react-query';
import type { MaintenanceNutritionTableResponse } from '../../../recommendations/types';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export function useGetAdviceMaintenanceNutritionTable(adviceId: string) {
	const forBinding = useForBindingId();

	return useQuery({
		queryKey: ['maintenance', adviceId, 'nutrition-table'],
		queryFn: async () => {
			try {
				const { data } = await api.get<MaintenanceNutritionTableResponse>(
					`/advices/nutrition-table/get/${adviceId}`,
					{ params: { forBinding } }
				);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao carregar a demanda atendida');
			}
		},
		enabled: !!adviceId,
	});
}
